import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorDialogComponent } from '../shared/info-dialogs/error-dialog/error-dialog.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private modalRef: NgbModalRef | null = null;

    constructor(
        private injector: Injector,
        private NgxUiLoaderService: NgxUiLoaderService
    ) {
        // Listen for network reconnect
        window.addEventListener('online', () => {
            if (this.modalRef) {
                this.modalRef.close();
                this.modalRef = null;
            }
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                this.NgxUiLoaderService.stop();
                console.log('Error Log:', error);

                let dialog = this.injector.get(NgbModal);
                const message = 'The server encountered an error and could not complete your request.';
                const messageAlternative = 'Please try again later or contact system administrator.';

                if (error) {
                    console.log('Skip-Error-Dialog');
                    console.log(req?.headers.get('Skip-Error-Dialog'));
                    console.log('error.status');
                    console.log(error.status);

                    const skipErrorDialog = req?.headers.get('Skip-Error-Dialog') === 'true';
                    if (skipErrorDialog) {
                        return throwError(() => error);
                    }
                    // if ((error.status === 401 || error.status === 502 || error.status === 0) && skipErrorDialog) {
                    //     return throwError(() => error);
                    // }

                    // Only open if not already open
                    if (!this.modalRef) {
                        this.modalRef = dialog.open(ErrorDialogComponent, { size: 'lg' });
                        this.modalRef.componentInstance.message = message;
                        this.modalRef.componentInstance.messageAlternative = messageAlternative;

                        this.modalRef.result.finally(() => {
                            this.modalRef = null; // reset after close
                        });
                    }
                    // setTimeout(() => {
                    //     if (this.modalRef) {
                    //         this.modalRef.close();
                    //         this.modalRef = null;
                    //     }
                    // }, 10000);
                }
                return throwError(() => error);
            })
        );
    }
}
